import styles from './MyInfo.module.css';

import { Seller } from '../Seller/Seller';

export const MyInfo = ({ user, onUserUpdate }) => {
    return (
        <div className={ styles.container }>
            <div className={ styles.titleBar }>
                <h3>My Info</h3>
            </div>

            <div className={ styles.content }>
                <Seller seller={ user } onUserUpdate={ onUserUpdate } />
            </div>
        </div>
    );
};